import Vue from "vue";
import ConfirmDialog from "@/core/components/dialogConfirmacao.vue";

const ConfirmDialogConstructor = Vue.extend(ConfirmDialog);

const confirmDialog = {
  install(Vue, { vuetify }) {
    Vue.prototype.$confirmacao = ({
      title,
      message,
      type,
      onConfirm,
      onCancel = () => {},
      confirmText = "Confirmar",
      cancelText = "Cancelar",
      tamanho = 500,
      hasInput = false,
      inputAttrs = {
        placeholder: "",
        maxlength: 255,
      },
    }) => {
      const instance = new ConfirmDialogConstructor({
        propsData: {
          title,
          message,
          type,
          onConfirm,
          onCancel,
          confirmText,
          cancelText,
          tamanho,
          hasInput,
          inputAttrs,
        },
        vuetify,
      });

      instance.$mount();
      document.body.appendChild(instance.$el);
      instance.open();
    };
  },
};

export default confirmDialog;
